import React, { ComponentProps } from 'react';
import { Select } from 'antd';
import useUsersMeta from '@hooks/useUsersMeta';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';

export const SexFormItem = ({
  selectProps,
  ...props
}: RegistrationFormItemProps & { selectProps?: Partial<ComponentProps<typeof Select>> }) => {
  const sexes = useUsersMeta()?.sexes;
  const { t } = useTranslation('common');

  const defaultSelectProps = {
    role: 'combobox' as const,
    'aria-expanded': false,
    'aria-required': true,
    'aria-label': 'Select your gender',
    ...selectProps
  };

  return (
    <RegistrationFormItem
      label={t('What is your sex?')}
      name="sex"
      rules={[{ required: true }]}
      tooltip={{
        title: t('sexAtBirthInfoText'),
        icon: <InfoCircleOutlined aria-hidden />,
        trigger: ['hover', 'focus']
      }}
      {...props}
    >
      <Select
        options={sexes?.map(({ sex_code, sex_desc }) => ({ label: sex_desc, value: sex_code }))}
        data-testid="sex-select"
        {...defaultSelectProps}
      />
    </RegistrationFormItem>
  );
};
